/* EntityEdit.jsx */
import React, { useState, useEffect, useRef } from 'react';
import './EntityEdit.css';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import {
    PhoneCall, Mail, MessageSquare, Mic,
    MoreVertical, Info, User, Edit2,
    Calendar, CheckCircle, Clock, MapPin,
    Search, Filter, ChevronLeft, ChevronRight,
    MessageCircle, Settings, Upload, ClipboardCheck,
    Percent, FileEdit, FileText, X
} from 'lucide-react';
import Loader from '../../../components/Loader/Loader';
import OperationsForms from './Operations/OperationsForms';

const NEW_ADDED_BASE_URL = (process.env.REACT_APP_BACKEND_BASEURL_FOR_DEVELOPMENT || '').replace(/\/$/, '');
const Get_EntityDeatils = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const center_of_edication = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.GET_CENTER_OF_EDUCATION_EDIT}`;
const Get_campaign_for_edit = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.GET_CAMPAIGN_FOR_EDIT}`;
const Get_country = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_COUNTRY}`;
const Get_State = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_STATE_BY_COUNTRY}`;
const Get_city_By_State = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_CITY_BY_STATE}`;
const SaveEdit = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.EDIT_LEAD_SAVE}`;
const Get_CustomFields = `${NEW_ADDED_BASE_URL}/UserCRM/GetCustomeFieldNameAndValueByParentAndLeadId`;
const TOKEN = (process.env.REACT_APP_TOKE_UNIVERSAL_TOKEN || '-2295521862261168');


const COUNTRY_MOBILE_VALIDATION = {
    'IN': { minLen: 10, maxLen: 10 }, 'US': { minLen: 10, maxLen: 10 },
    'GB': { minLen: 10, maxLen: 11 }, 'AU': { minLen: 9, maxLen: 9 },
    'CA': { minLen: 10, maxLen: 10 }, 'AE': { minLen: 9, maxLen: 9 },
    'SA': { minLen: 9, maxLen: 9 },  'QA': { minLen: 8, maxLen: 8 },
    'SG': { minLen: 8, maxLen: 8 },  'MY': { minLen: 9, maxLen: 10 },
    'PK': { minLen: 10, maxLen: 10 }, 'BD': { minLen: 10, maxLen: 10 },
    'NP': { minLen: 10, maxLen: 10 }, 'LK': { minLen: 9, maxLen: 9 },
    'KW': { minLen: 8, maxLen: 8 },  'BH': { minLen: 8, maxLen: 8 },
    'OM': { minLen: 8, maxLen: 8 },  'JO': { minLen: 9, maxLen: 9 },
    'DE': { minLen: 10, maxLen: 11 }, 'FR': { minLen: 9, maxLen: 9 },
    'IT': { minLen: 9, maxLen: 10 }, 'ES': { minLen: 9, maxLen: 9 },
    'RU': { minLen: 10, maxLen: 10 }, 'CN': { minLen: 11, maxLen: 11 },
    'JP': { minLen: 10, maxLen: 11 }, 'ZA': { minLen: 9, maxLen: 9 },
    'NG': { minLen: 10, maxLen: 10 }, 'BR': { minLen: 10, maxLen: 11 },
    'MX': { minLen: 10, maxLen: 10 }, 'PH': { minLen: 10, maxLen: 10 },
};

const DEFAULT_COUNTRY = { code: '+91', flag: 'https://flagcdn.com/w320/in.png', name: 'India', cca2: 'IN' };

const cleanMobileForSave = (rawMobile, dialCode) => {
    if (!rawMobile) return '';
    let num = String(rawMobile).replace(/\s+/g, '');
    const code = String(dialCode || '').replace(/[+\s]/g, '');
    if (num.startsWith('+')) num = num.slice(1);
    if (code && num.startsWith(code)) num = num.slice(code.length);
    return num;
};

const validateMobile = (rawMobile, cca2) => {
    if (!rawMobile) return null;
    const digits = String(rawMobile).replace(/\D/g, '');
    const rules = COUNTRY_MOBILE_VALIDATION[cca2];
    if (!rules) return null;
    if (digits.length < rules.minLen || digits.length > rules.maxLen) {
        return `Must be ${rules.minLen === rules.maxLen ? rules.minLen : rules.minLen + '-' + rules.maxLen} digits`;
    }
    return null;
};

export const EntityEdit = ({ editingEntity, onCloseEntity }) => {
    const [editEntityData, setEditEntityData] = useState({});
    const [tagInputValue, setTagInputValue] = useState("");
    const [isEditEntityLoading, setIsEditEntityLoading] = useState(false);
    const [saveMessage, setSaveMessage] = useState({ type: '', text: '' });
    const [currentOperationMode, setCurrentOperationMode] = useState('none');
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);

    // Fetch Lead Details for child components
    const leadId = editingEntity?.enquiryId || editingEntity?.leadId || editingEntity?.id;

    // Dropdown States for Main Entity Edit
    const [countries, setCountries] = useState([]);
    const [originalEntityData, setOriginalEntityData] = useState(null);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [sources, setSources] = useState([]);
    const [mediums, setMediums] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [centerOptions, setCenterOptions] = useState([]);
    const [isStatesLoading, setIsStatesLoading] = useState(false);
    const [isCitiesLoading, setIsCitiesLoading] = useState(false);
    const [customFields, setCustomFields] = useState([]);

    // Rest Countries States
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState({
        Mobile: DEFAULT_COUNTRY, MobileNo1: DEFAULT_COUNTRY, MobileNo2: DEFAULT_COUNTRY
    });
    const [mobileErrors, setMobileErrors] = useState({ Mobile: null, MobileNo1: null, MobileNo2: null });
    const [activeCountryDropdown, setActiveCountryDropdown] = useState(null);
    const [countrySearch, setCountrySearch] = useState('');
    const countryDropdownRef = useRef(null);
    const fileInputRef = useRef(null);

    // Dynamic Fields State
    const [mobileFields, setMobileFields] = useState(['Mobile']); // Keys: Mobile, MobileNo1, MobileNo2
    const [emailFields, setEmailFields] = useState(['Email']);   // Keys: Email, EmailID1, EmailID2

    useEffect(() => {
        if (editingEntity) {
            fetchEntityDetails();
            fetchCountries();
            fetchRestCountries();
            fetchSourceMediumCampaign('SourceName', setSources);
            fetchSourceMediumCampaign('MediumName', setMediums);
            fetchSourceMediumCampaign('CampaignName', setCampaigns);
            fetchCourseAndCenterOptions();
            fetchCustomFields();
        } else {
            setEditEntityData({});
            setCustomFields([]);
            setMobileFields(['Mobile']);
            setEmailFields(['Email']);
        }
    }, [editingEntity]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
                setActiveCountryDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (editEntityData.countrycode || editEntityData.CountryCode || editEntityData.Country) {
            const code = editEntityData.countrycode || editEntityData.CountryCode || editEntityData.Country;
            if (allCountries.length > 0) {
                const cleanCode = code.toString().replace('+', '');
                const found = allCountries.find(f =>
                    f.cca2 === code ||
                    f.name === code ||
                    f.code.toString().replace('+', '') === cleanCode
                );
            }
        }
    }, [editEntityData.countrycode, editEntityData.CountryCode, editEntityData.Country, allCountries]);

    const fetchRestCountries = async () => {
        try {
            const response = await fetch('https://raw.githubusercontent.com/mledoze/countries/master/countries.json');
            const data = await response.json();
            const formatted = data.map(c => {
                const root = c.idd?.root || '';
                const baseSuffix = (c.idd?.suffixes && c.idd.suffixes.length > 0) ? c.idd.suffixes[0] : '';
                return {
                    name: c.name.common,
                    flag: c.flags?.png || `https://flagcdn.com/w320/${(c.cca2 || '').toLowerCase()}.png`,
                    code: root + baseSuffix,
                    cca2: c.cca2
                };
            }).filter(c => c.name && c.code).sort((a, b) => a.name.localeCompare(b.name));
            setAllCountries(formatted);

            // Attempt to sync with existing data if available
            if (editEntityData.countrycode) {
                const found = formatted.find(f => f.cca2 === editEntityData.countrycode);
            }
        } catch (error) {
            console.error("Error fetching REST countries:", error);
        }
    };

    const fetchCountries = async () => {
        try {
            const response = await fetch(Get_country, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setCountries(Array.isArray(list) ? list : []);
        } catch (error) { console.error("Error fetching countries:", error); }
    };

    const renderAvatar = (name, url = null, size = 'sm') => {
        if (url) {
            return <img src={url} alt="" style={{ width: size === 'lg' ? '60px' : '40px', height: size === 'lg' ? '60px' : '40px', borderRadius: '50%', objectFit: 'cover' }} />;
        }
        const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : '??';
        const colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a69a', '#4caf50', '#ff9800', '#ff5722'];
        const colorIdx = (initials.charCodeAt(0) + (initials.charCodeAt(1) || 0)) % colors.length;
        const bgColor = colors[colorIdx];

        return (
            <div className={`avatar-initials-circle ${size}`} style={{
                backgroundColor: bgColor,
                position: 'relative',
                width: size === 'lg' ? '60px' : '40px',
                height: size === 'lg' ? '60px' : '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: size === 'lg' ? '24px' : '14px'
            }}>
                {initials}
                <div style={{
                    position: 'absolute',
                    top: '-4px',
                    left: '-4px',
                    width: '18px',
                    height: '18px',
                    backgroundColor: '#4a90e2',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid white',
                    fontWeight: 'bold',
                    zIndex: 1
                }}>0</div>
            </div>
        );
    };

    const fetchStates = async (countryId) => {
        if (!countryId) return; setIsStatesLoading(true);
        try {
            const response = await fetch(Get_State, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ CountryId: countryId.toString() }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setStates(Array.isArray(list) ? list : []);
            setCities([]);
        } catch (error) { console.error("Error fetching states:", error); } finally { setIsStatesLoading(false); }
    };

    const fetchCities = async (stateId) => {
        if (!stateId) return; setIsCitiesLoading(true);
        try {
            const response = await fetch(Get_city_By_State, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ StateId: stateId.toString() }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setCities(Array.isArray(list) ? list : []);
        } catch (error) { console.error("Error fetching cities:", error); } finally { setIsCitiesLoading(false); }
    };

    const fetchSourceMediumCampaign = async (type, setter) => {
        try {
            const response = await fetch(Get_campaign_for_edit, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ UserId: "34594", type: type }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setter(Array.isArray(list) ? list : []);
        } catch (error) { console.error(`Error fetching ${type}:`, error); }
    };

    const fetchCourseAndCenterOptions = async () => {
        try {
            const response = await fetch(center_of_edication, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ CustomFieldIds: 5292, ParentId: "34594" }) });
            const data = await response.json();
            const raw = data?.d || data?.Details || data?.Data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : raw;
            const item = Array.isArray(list) ? list[0] : list;
            if (item?.Choices) setCourseOptions(item.Choices.split(',').map(s => s.trim()).filter(Boolean));
            if (item?.CenterChoices) setCenterOptions(item.CenterChoices.split(',').map(s => s.trim()).filter(Boolean));
            else if (item?.Choices) setCenterOptions(item.Choices.split(',').map(s => s.trim()).filter(Boolean));
        } catch (error) { console.error("Error fetching course/center options:", error); }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setEditEntityData({ ...editEntityData, ProfileImgFileName: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const fetchCustomFields = async () => {
        if (!editingEntity) return;
        try {
            const entityLeadId = editingEntity.enquiryId || editingEntity.leadId || editingEntity.id;
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    entityId: entityLeadId.toString(),
                    ParentId: userId
                }
            };
            const response = await fetch(Get_CustomFields, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            // Handle both ASMX (data.d) and REST (data.Details / data) responses
            let raw = data?.d || data?.Details || data?.data || data;
            if (typeof raw === 'string') { try { raw = JSON.parse(raw); } catch (e) { raw = []; } }
            if (Array.isArray(raw) && raw.length > 0) {
                // Each item expected to have FieldName, FieldValue, FieldType, Choices
                const mappedFields = raw.map(f => ({
                    key: f.FieldName || f.fieldName || f.Field || f.Key || '',
                    value: f.FieldValue || f.fieldValue || f.Value || '',
                    fieldType: (f.FieldType || f.fieldType || '').toLowerCase(),
                    choices: f.Choices || f.choices || '',
                    fieldId: f.FieldId || f.CustomFieldId || f.fieldId || ''
                })).filter(f => f.key);
                setCustomFields(mappedFields);
            } else {
                setCustomFields([]);
            }
        } catch (error) { console.error("Error fetching custom fields:", error); }
    };


    const fetchEntityDetails = async () => {
        if (!editingEntity) return;
        setIsEditEntityLoading(true);
        try {
            const entityLeadId = editingEntity.enquiryId || editingEntity.leadId || editingEntity.id;
            const payload = { Token: TOKEN, Details: { LeadId: parseInt(entityLeadId, 10), ParentId: localStorage.getItem('userId') || '34594' } };
            const response = await fetch(Get_EntityDeatils, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const data = await response.json();
            let mappedData = {};
            const KNOWN_FIELDS = new Set(['leadid', 'LeadId', 'LeadID', 'leadno', 'leadnumber', 'LeadNo', 'LeadNumber', 'leadNo', 'personname', 'Name', 'companyname', 'Company', 'mobileno', 'Mobile', 'phones', 'emailid', 'Email', 'emails', 'sourceid', 'SourceId', 'sourceId', 'SourceID', 'source', 'Source', 'mediumid', 'MediumId', 'mediumId', 'MediumID', 'medium', 'Medium', 'campaignid', 'CampaignId', 'campaignId', 'CampaignID', 'campaignname', 'Campaign', 'residentialaddress', 'Address', 'ResidentialAddress', 'officeaddress', 'OfficialAddress', 'remark', 'Remarks', 'pincode', 'Pincode', 'groups', 'Tags', 'cityid', 'city', 'cityId', 'stateid', 'state', 'stateId', 'countryid', 'country', 'CountryId', 'ProfileImgFileName', 'countrycode']);
            if (data?.Details) {
                const inner = typeof data.Details === 'string' ? JSON.parse(data.Details) : data.Details;
                const raw = Array.isArray(inner) ? inner[0] : (inner || {});
                mappedData = {
                    ...raw,
                    LeadId: raw.leadid || raw.LeadId || raw.LeadID || '',
                    LeadNo: raw.leadno || raw.leadnumber || raw.LeadNo || raw.LeadNumber || raw.leadNo || '',
                    Name: raw.personname || raw.Name || '',
                    Company: raw.companyname || raw.Company || '',
                    Mobile: raw.mobileno || raw.Mobile || raw.phones || '',
                    Email: raw.emailid || raw.Email || raw.emails || '',
                    Source: raw.sourceid || raw.SourceId || raw.sourceId || raw.SourceID || raw.source || raw.Source || '',
                    Medium: raw.mediumid || raw.MediumId || raw.mediumId || raw.MediumID || raw.medium || raw.Medium || '',
                    Campaign: raw.campaignid || raw.CampaignId || raw.campaignId || raw.CampaignID || raw.campaignname || raw.Campaign || '',
                    ResidentialAddress: raw.residentialaddress || raw.Address || '',
                    OfficialAddress: raw.officeaddress || '',
                    Remarks: raw.remark || raw.Remarks || '',
                    Pincode: raw.pincode || '',
                    Tags: raw.groups || raw.Tags || '',
                    cityId: raw.cityid || raw.city || '',
                    stateId: raw.stateid || raw.state || '',
                    CountryId: raw.countryid || raw.country || '',
                    countrycode: raw.countrycode || raw.CountryCode || ''
                };

                // Sync dynamic fields
                const mFields = ['Mobile'];
                if (raw.MobileNo1 || raw.Mobile1) mFields.push('MobileNo1');
                if (raw.MobileNo2 || raw.Mobile2) mFields.push('MobileNo2');
                setMobileFields(mFields);
                // Sync per-field country from stored countrycode
                const storedCca2 = raw.countrycode || raw.CountryCode || 'IN';
                setSelectedCountries(prev => ({
                    Mobile: prev.Mobile,
                    MobileNo1: prev.MobileNo1,
                    MobileNo2: prev.MobileNo2
                }));

                const eFields = ['Email'];
                if (raw.EmailID1 || raw.Email1) eFields.push('EmailID1');
                if (raw.EmailID2 || raw.Email2) eFields.push('EmailID2');
                setEmailFields(eFields);

                // Extract all custom/additional fields from the API
                const extras = Object.entries(raw)
                    .filter(([key]) => !KNOWN_FIELDS.has(key))
                    .map(([key, value]) => ({ key, value: value == null ? '' : String(value) }));
                setCustomFields(extras);
            }
            setEditEntityData(mappedData);
            setOriginalEntityData({ ...mappedData });
        } catch (error) { console.error("Error fetching entity details:", error); } finally { setIsEditEntityLoading(false); }
    };

    const handleReset = () => {
        if (originalEntityData) {
            setEditEntityData({ ...originalEntityData });
            setSaveMessage({ text: 'Form reset to original values', type: 'success' });
            setTimeout(() => setSaveMessage({ text: '', type: '' }), 3000);
        }
    };

    const handleSave = async () => {
        try {
            const rootUserId = localStorage.getItem('userId') || "34594";
            const rootParentId = "34594";
            const d = editEntityData;
            const leadId = d.LeadId || editingEntity?.enquiryId || editingEntity?.leadId || editingEntity?.id || "";

            const lstCustomField = []; // Simplified for now but keeping original structure

            // Validate mobile numbers
            const mobileValidationErrors = {};
            mobileFields.forEach(fk => {
                const err = validateMobile(d[fk], selectedCountries[fk]?.cca2);
                if (err) mobileValidationErrors[fk] = err;
            });
            if (Object.keys(mobileValidationErrors).length > 0) {
                setMobileErrors(mobileValidationErrors);
                setSaveMessage({ type: 'error', text: 'Please fix mobile number errors before saving.' });
                setTimeout(() => setSaveMessage({ type: '', text: '' }), 3000);
                setIsEditEntityLoading(false);
                return;
            }
            setMobileErrors({});

            const buildMobile = (fieldKey) => {
                const mob = d[fieldKey] || '';
                if (!mob) return '';
                const ctr = selectedCountries[fieldKey] || DEFAULT_COUNTRY;
                const dc = String(ctr.code || '+91').replace('+', '');
                const cleaned = cleanMobileForSave(mob, dc);
                return dc + cleaned;
            };

            const objLead_BO = {
                LeadId: leadId.toString(), LeadNo: d.LeadNo?.toString() || "", PersonName: d.Name || "", CompanyName: d.Company || "",
                MobileNo: buildMobile('Mobile'),
                MobileNo1: mobileFields.includes('MobileNo1') ? buildMobile('MobileNo1') : '',
                MobileNo2: mobileFields.includes('MobileNo2') ? buildMobile('MobileNo2') : '',
                EmailID: d.Email || "", City: d.cityId || d.City || "", State: d.stateId || d.State || "", Country: d.CountryId || d.Country || "",
                PinCode: d.Pincode?.toString() || "0", SourceName: d.Source || "0", MediumName: d.Medium || "0", CampaignName: d.Campaign || "0",
                ResidentialAddress: d.ResidentialAddress || "", OfficialAddress: d.OfficialAddress || "",
                CountryCode: selectedCountries.Mobile?.cca2 || d.countrycode || "IN",
                CountryCode1: selectedCountries.MobileNo1?.cca2 || "IN",
                CountryCode2: selectedCountries.MobileNo2?.cca2 || "IN",
                InitialRemarks: d.Remarks || "", Remarks: d.Remarks || "",
                LeadTags: d.Tags || "", ProfileImgFileName: d.ProfileImgFileName || "", lstCustomField
            };

            const payload = { objLead_BO, ParentId: rootParentId, UserId: rootUserId };
            setIsEditEntityLoading(true);
            const response = await fetch(SaveEdit, { method: 'POST', headers: { "Content-Type": "application/json; charset=utf-8" }, body: JSON.stringify(payload) });
            if (response.ok) {
                setSaveMessage({ type: 'success', text: 'Lead details updated successfully!' });
                setTimeout(() => onCloseEntity(), 2000);
            } else { setSaveMessage({ type: 'error', text: `Failed to save. Status: ${response.status}` }); }
        } catch (error) {
            console.error("Error saving entity:", error);
            setSaveMessage({ type: 'error', text: 'An error occurred while saving.' });
        } finally {
            setIsEditEntityLoading(false);
        }
    };

    if (!editingEntity) return null;

    return (
        <div className="entity-edit-overlay" onClick={onCloseEntity}>
            <div className="entity-edit-panel" onClick={e => e.stopPropagation()}>
                <div className="entity-edit-header">
                    <div className="entity-header-left">
                        <button
                            className="entity-settings-trigger"
                            onClick={(e) => { e.stopPropagation(); setShowSettingsMenu(!showSettingsMenu); }}
                            title="Operations"
                        >
                            <Settings size={18} />
                        </button>
                        {showSettingsMenu && (
                            <div className="entity-header-dropdown">
                                {[
                                    { label: 'Send Mail', mode: 'mail', icon: Mail },
                                    { label: 'Send SMS', mode: 'sms', icon: MessageSquare },
                                    { label: 'Send Voice', mode: 'voice', icon: Mic },
                                    { label: 'WhatsApp', mode: 'whatsapp', icon: MessageCircle }
                                ].map(item => (
                                    <button
                                        key={item.mode}
                                        className={`entity-dropdown-item ${currentOperationMode === item.mode ? 'active' : ''}`}
                                        onClick={() => {
                                            setCurrentOperationMode(item.mode);
                                            setShowSettingsMenu(false);
                                        }}
                                    >
                                        <item.icon size={14} className="dropdown-icon" />
                                        <span>{item.label}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                        <h3>Edit Entity</h3>
                    </div>
                    <div className="entity-header-actions">
                        <button className="entity-reset-btn" onClick={handleReset}>Reset</button>
                        <button className="entity-save-btn" onClick={handleSave}>Save Changes</button>
                        <button className="entity-edit-close" onClick={onCloseEntity}><X size={20} /></button>
                    </div>
                </div>

                {saveMessage.text && (
                    <div style={{ padding: '8px 15px', margin: '5px 15px', borderRadius: '4px', backgroundColor: saveMessage.type === 'success' ? '#d4edda' : '#f8d7da', color: saveMessage.type === 'success' ? '#155724' : '#721c24', fontSize: '13px' }}>
                        {saveMessage.text}
                    </div>
                )}

                <div className="entity-edit-main-container">
                    <div className="entity-edit-content">
                        <div className="entity-edit-body">
                            {isEditEntityLoading ? <div style={{ padding: '50px', textAlign: 'center' }}><Loader /></div> : (
                                <>
                                    <div className="entity-section">
                                        <div className="entity-section-title">Basic Details</div>
                                        <div className="entity-basic-row">
                                            <div className="entity-avatar-box">
                                                <div className="entity-avatar-inner" style={{ background: 'transparent' }}>
                                                    {renderAvatar(editEntityData.Name, editEntityData.ProfileImgFileName || 'https://kit19.com/assets/custom/img/img_avatar1.png', 'lg')}
                                                    <div className="entity-avatar-edit-trigger" onClick={() => fileInputRef.current.click()}>
                                                        <Edit2 size={12} />
                                                    </div>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="entity-basic-fields">
                                                <div className="entity-grid-2">
                                                    <div className="entity-field-group">
                                                        <label>Name<span className="required">*</span></label>
                                                        <input type="text" className="entity-input" value={editEntityData.Name || ''} onChange={e => setEditEntityData({ ...editEntityData, Name: e.target.value })} />
                                                    </div>
                                                    <div className="entity-field-group">
                                                        <label>Company</label>
                                                        <input type="text" className="entity-input" value={editEntityData.Company || ''} onChange={e => setEditEntityData({ ...editEntityData, Company: e.target.value })} />
                                                    </div>
                                                </div>
                                                <div className="dynamic-field-section">
                                                    {mobileFields.map((fieldKey, index) => (
                                                        <div className="entity-grid-2" key={fieldKey}>
                                                            <div className="entity-field-group">
                                                                <label>{index === 0 ? 'Mobile' : `Mobile ${index}`}</label>
                                                                <div className="entity-phone-input-wrapper">
                                                                    <div className="flag-select" onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setCountrySearch('');
                                                                        setActiveCountryDropdown(activeCountryDropdown === fieldKey ? null : fieldKey);
                                                                    }}>
                                                                        <div className="flag-select-inner">
                                                                            <img src={selectedCountries[fieldKey]?.flag || DEFAULT_COUNTRY.flag} alt="" className="selected-flag" />
                                                                        </div>
                                                                        <span className="country-calling-code">+{String(selectedCountries[fieldKey]?.code || '+91').replace('+', '')}</span>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className={`entity-input${mobileErrors[fieldKey] ? ' input-error' : ''}`}
                                                                        placeholder="Mobile Number"
                                                                        value={editEntityData[fieldKey] || ''}
                                                                        onChange={e => {
                                                                            const val = e.target.value.replace(/\s+/g, '');
                                                                            setEditEntityData({ ...editEntityData, [fieldKey]: val });
                                                                            const err = validateMobile(val, selectedCountries[fieldKey]?.cca2);
                                                                            setMobileErrors(prev => ({ ...prev, [fieldKey]: err }));
                                                                        }}
                                                                    />
                                                                    {activeCountryDropdown === fieldKey && (
                                                                        <div className="country-dropdown-panel" ref={countryDropdownRef}>
                                                                            <div style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Search country..."
                                                                                    value={countrySearch}
                                                                                    onChange={e => setCountrySearch(e.target.value)}
                                                                                    onClick={e => e.stopPropagation()}
                                                                                    style={{ width: '100%', padding: '4px 8px', border: '1px solid #ddd', borderRadius: 4, fontSize: 12 }}
                                                                                />
                                                                            </div>
                                                                            <div className="country-options-list">
                                                                                {allCountries
                                                                                    .filter(c => c.name.toLowerCase().includes(countrySearch.toLowerCase()) || c.code.includes(countrySearch))
                                                                                    .map((c, i) => (
                                                                                    <div key={i} className="country-option-item" onClick={() => {
                                                                                        setSelectedCountries(prev => ({ ...prev, [fieldKey]: c }));
                                                                                        setMobileErrors(prev => ({ ...prev, [fieldKey]: null }));
                                                                                        setActiveCountryDropdown(null);
                                                                                        setCountrySearch('');
                                                                                    }}>
                                                                                        <img src={c.flag} alt="" className="option-flag" />
                                                                                        <span className="option-name">{c.name}</span>
                                                                                        <span style={{ marginLeft: 'auto', fontSize: 11, color: '#666' }}>+{c.code.replace('+', '')}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {index === 0 ? (
                                                                        <button className="plus-btn" onClick={() => {
                                                                            if (mobileFields.length < 3) {
                                                                                const nextKey = mobileFields.length === 1 ? 'MobileNo1' : 'MobileNo2';
                                                                                setMobileFields([...mobileFields, nextKey]);
                                                                            }
                                                                        }}>+</button>
                                                                    ) : (
                                                                        <button className="minus-btn" onClick={() => {
                                                                            const updated = mobileFields.filter(f => f !== fieldKey);
                                                                            setMobileFields(updated);
                                                                            const newData = { ...editEntityData };
                                                                            delete newData[fieldKey];
                                                                            setEditEntityData(newData);
                                                                        }}>-</button>
                                                                    )}
                                                                </div>
                                                                {mobileErrors[fieldKey] && (
                                                                    <span style={{ color: '#e53e3e', fontSize: 11, marginTop: 2, display: 'block' }}>{mobileErrors[fieldKey]}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {emailFields.map((fieldKey, index) => (
                                                        <div className="entity-grid-2" key={fieldKey}>
                                                            <div className="entity-field-group">
                                                                <label>{index === 0 ? 'Email' : `Email ${index}`}</label>
                                                                <div className="entity-email-input-wrapper">
                                                                    <input
                                                                        type="email"
                                                                        className="entity-input"
                                                                        value={editEntityData[fieldKey] || ''}
                                                                        onChange={e => setEditEntityData({ ...editEntityData, [fieldKey]: e.target.value })}
                                                                    />
                                                                    {index === 0 ? (
                                                                        <button className="plus-btn" onClick={() => {
                                                                            if (emailFields.length < 3) {
                                                                                const nextKey = emailFields.length === 1 ? 'EmailID1' : 'EmailID2';
                                                                                setEmailFields([...emailFields, nextKey]);
                                                                            }
                                                                        }}>+</button>
                                                                    ) : (
                                                                        <button className="minus-btn" onClick={() => {
                                                                            const updated = emailFields.filter(f => f !== fieldKey);
                                                                            setEmailFields(updated);
                                                                            const newData = { ...editEntityData };
                                                                            delete newData[fieldKey];
                                                                            setEditEntityData(newData);
                                                                        }}>-</button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="entity-section">
                                        <div className="entity-grid-3">
                                            <div className="entity-field-group">
                                                <label>Country</label>
                                                <select className="entity-select" value={editEntityData.CountryId || ''} onChange={e => {
                                                    const val = e.target.value;
                                                    const selectedOpt = countries.find(c => String(c.Id || c.Code || c.Value || c.countryid || c.id || c.ID || '') === val);
                                                    const cName = selectedOpt ? (selectedOpt.Text || selectedOpt.Name || selectedOpt.name || '') : '';
                                                    // Sync phone country code from allCountries
                                                    const matched = allCountries.find(ac => ac.name.toLowerCase() === cName.toLowerCase());
                                                    if (matched) {
                                                        setSelectedCountries(prev => ({ Mobile: matched, MobileNo1: prev.MobileNo1, MobileNo2: prev.MobileNo2 }));
                                                    }
                                                    setEditEntityData({ ...editEntityData, CountryId: val, stateId: '', cityId: '' });
                                                    fetchStates(val);
                                                }}>
                                                    <option value="">Select Country</option>
                                                    {countries.map((c, idx) => (
                                                        <option key={idx} value={c.Id || c.Code || c.Value || c.countryid || c.id || c.ID || ''}>
                                                            {c.Text || c.Name || c.Name1 || c.Value || c.countryname || c.CountryName || c.name || c.text || c.label || c.Country_Name || `Country ${idx + 1}`}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>State</label>
                                                <select className="entity-select" value={editEntityData.stateId || ''} onChange={e => { setEditEntityData({ ...editEntityData, stateId: e.target.value, cityId: '' }); fetchCities(e.target.value); }} disabled={isStatesLoading}>
                                                    <option value="">{isStatesLoading ? 'Loading...' : 'Select State'}</option>
                                                    {states.map((s, idx) => (
                                                        <option key={idx} value={s.Id || s.Code || s.Value || s.stateid || s.id || s.ID || ''}>
                                                            {s.Text || s.Name || s.Name1 || s.Value || s.statename || s.StateName || s.name || s.text || s.label || s.State_Name || `State ${idx + 1}`}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>City</label>
                                                <select className="entity-select" value={editEntityData.cityId || ''} onChange={e => setEditEntityData({ ...editEntityData, cityId: e.target.value })} disabled={isCitiesLoading}>
                                                    <option value="">{isCitiesLoading ? 'Loading...' : 'Select City'}</option>
                                                    {cities.map((c, idx) => (
                                                        <option key={idx} value={c.Id || c.Code || c.Value || c.cityid || c.id || c.ID || ''}>
                                                            {c.Text || c.Name || c.Name1 || c.Value || c.cityname || c.CityName || c.name || c.text || c.label || c.City_Name || `City ${idx + 1}`}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="entity-section">
                                        <div className="entity-section-title">Other Details</div>
                                        <div className="entity-grid-3">
                                            <div className="entity-field-group">
                                                <label>Medium</label>
                                                <select className="entity-select" value={editEntityData.Medium || ''} onChange={e => setEditEntityData({ ...editEntityData, Medium: e.target.value })}>
                                                    <option value="">Select Medium</option>
                                                    {mediums.map(m => <option key={m.SrcmedCampID} value={m.SrcmedCampID}>{m.SrcmedCampName || m.Name}</option>)}
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Campaign</label>
                                                <select className="entity-select" value={editEntityData.Campaign || ''} onChange={e => setEditEntityData({ ...editEntityData, Campaign: e.target.value })}>
                                                    <option value="">Select Campaign</option>
                                                    {campaigns.map(c => <option key={c.SrcmedCampID} value={c.SrcmedCampID}>{c.SrcmedCampName || c.Name}</option>)}
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Source <span className="required">*</span></label>
                                                <select className="entity-select" value={editEntityData.Source || ''} onChange={e => setEditEntityData({ ...editEntityData, Source: e.target.value })}>
                                                    <option value="">Select Source</option>
                                                    {sources.map(s => <option key={s.SrcmedCampID} value={s.SrcmedCampID}>{s.SrcmedCampName || s.Name}</option>)}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="entity-grid-2" style={{ marginTop: '15px' }}>
                                            <div className="entity-field-group">
                                                <label>Residential Address</label>
                                                <textarea className="entity-textarea" value={editEntityData.ResidentialAddress || ''} onChange={e => setEditEntityData({ ...editEntityData, ResidentialAddress: e.target.value })} placeholder="Dehradun" />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Official Address</label>
                                                <input type="text" className="entity-input" value={editEntityData.OfficialAddress || ''} onChange={e => setEditEntityData({ ...editEntityData, OfficialAddress: e.target.value })} placeholder="Official Address" />
                                            </div>
                                        </div>
                                        <div className="entity-grid-2" style={{ marginTop: '10px' }}>
                                            <div className="entity-field-group">
                                                <label>Initial Remarks</label>
                                                <textarea className="entity-textarea entity-input" value={editEntityData.Remarks || ''} onChange={e => setEditEntityData({ ...editEntityData, Remarks: e.target.value })} placeholder="Enter initial remarks..." />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Pincode</label>
                                                <input type="text" className="entity-input" value={editEntityData.Pincode || ''} onChange={e => setEditEntityData({ ...editEntityData, Pincode: e.target.value })} placeholder="Pincode" />
                                            </div>
                                        </div>
                                        <div className="entity-field-group" style={{ padding: '0 10px', marginTop: '10px' }}>
                                            <label>Lead Tags</label>
                                            <div className="entity-tags-wrapper">
                                                <div className="tags-pill-container" style={{
                                                    display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '6px',
                                                    border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', minHeight: '38px'
                                                }}>
                                                    {(editEntityData.Tags || '').split(',').map((tag, idx) => tag.trim() ? (
                                                        <span key={idx} className="tag-pill" style={{
                                                            backgroundColor: '#eaf4e6', color: '#6ab04c', padding: '3px 8px',
                                                            borderRadius: '14px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px'
                                                        }}>
                                                            {tag.trim()}
                                                            <X size={12} style={{ cursor: 'pointer', color: '#6ab04c' }}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    const newTags = (editEntityData.Tags || '').split(',').map(t => t.trim()).filter(Boolean);
                                                                    newTags.splice(idx, 1);
                                                                    setEditEntityData({ ...editEntityData, Tags: newTags.join(', ') });
                                                                }}
                                                            />
                                                        </span>
                                                    ) : null)}
                                                    <div style={{ position: 'relative', flexGrow: 1, minWidth: '150px' }}>
                                                        <input
                                                            type="text"
                                                            value={tagInputValue}
                                                            placeholder="Search tags or add..."
                                                            style={{ border: 'none', outline: 'none', width: '100%', padding: '4px 0', fontSize: '13px', backgroundColor: 'transparent' }}
                                                            onChange={e => setTagInputValue(e.target.value)}
                                                            onKeyDown={e => {
                                                                if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
                                                                    e.preventDefault();
                                                                    const val = tagInputValue.trim();
                                                                    if (val) {
                                                                        const existing = (editEntityData.Tags || '').split(',').map(t => t.trim()).filter(Boolean);
                                                                        const newValues = val.split(',').map(v => v.trim()).filter(Boolean);
                                                                        const combined = [...existing];
                                                                        newValues.forEach(nv => {
                                                                            if (!combined.includes(nv)) combined.push(nv);
                                                                        });
                                                                        setEditEntityData({ ...editEntityData, Tags: combined.join(', ') });
                                                                        setTagInputValue("");
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <small style={{ color: '#6ab04c', background: '#eaf4e6', padding: '6px 10px', display: 'block', marginTop: '6px', borderRadius: '4px', fontSize: '11px', lineHeight: '1.4' }}>
                                                    Please press comma, tab, or enter key for generating the tag name, or you can also generate a tag by copy and paste with comma separated value.
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Additional Custom Fields Section - matching FollowUp module pattern */}
                                    <div className="entity-section">
                                        <div className="entity-section-title">Additional Fields</div>
                                        <div className="entity-grid-3">

                                            {/* Row 1 */}
                                            <div className="entity-field-group">
                                                <label>Amount</label>
                                                <input type="text" className="entity-input" value={editEntityData?.amount || ''} onChange={(e) => setEditEntityData({ ...editEntityData, amount: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Service</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Service || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Service: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Charges</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Charges || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Charges: e.target.value })} />
                                            </div>

                                            {/* Row 2 */}
                                            <div className="entity-field-group">
                                                <label>Bank Name</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bank_Name_okl || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bank_Name_okl: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Bill Amount</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bill_Amount || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bill_Amount: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Due Date</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Due_Date ? editEntityData.Due_Date.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Due_Date: e.target.value })} />
                                            </div>

                                            {/* Row 3 */}
                                            <div className="entity-field-group">
                                                <label>Card Status</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Status || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Status: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Card Type</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Type || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Type: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Bank Name 2</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bank_Name_okl_2 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bank_Name_okl_2: e.target.value })} />
                                            </div>

                                            {/* Row 4 */}
                                            <div className="entity-field-group">
                                                <label>Bill Amount 2</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bill_Amount_2 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bill_Amount_2: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Due Date 2</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Due_Date_2 ? editEntityData.Due_Date_2.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Due_Date_2: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Card Status 2</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Status_2 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Status_2: e.target.value })} />
                                            </div>

                                            {/* Row 5 */}
                                            <div className="entity-field-group">
                                                <label>Card Type 2</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Type_2 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Type_2: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Bank Name 3</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bank_Name_okl_3 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bank_Name_okl_3: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Bill Amount 3</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Bill_Amount_3 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Bill_Amount_3: e.target.value })} />
                                            </div>

                                            {/* Row 6 */}
                                            <div className="entity-field-group">
                                                <label>Due Date 3</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Due_Date_3 ? editEntityData.Due_Date_3.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Due_Date_3: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Card Status 3</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Status_3 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Status_3: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Card Type 3</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Card_Type_3 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Card_Type_3: e.target.value })} />
                                            </div>

                                            {/* Row 7 */}
                                            <div className="entity-field-group">
                                                <label>Client ID</label>
                                                <input type="text" className="entity-input" value={editEntityData?.ClientID || ''} onChange={(e) => setEditEntityData({ ...editEntityData, ClientID: e.target.value })} placeholder="0" />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>DOB</label>
                                                <input type="date" className="entity-input" value={editEntityData?.DOB ? editEntityData.DOB.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, DOB: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>NAME</label>
                                                <input type="text" className="entity-input" value={editEntityData?.NAME || ''} onChange={(e) => setEditEntityData({ ...editEntityData, NAME: e.target.value })} placeholder="0" />
                                            </div>

                                            {/* Row 8 */}
                                            <div className="entity-field-group">
                                                <label>Study Level</label>
                                                <select className="entity-select" value={editEntityData?.StudyLevel || ''} onChange={(e) => setEditEntityData({ ...editEntityData, StudyLevel: e.target.value })}>
                                                    <option value="">Select</option>
                                                    <option value="Diploma">Diploma</option>
                                                    <option value="Graduate">Graduate</option>
                                                    <option value="Post Graduate">Post Graduate</option>
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Course</label>
                                                <select className="entity-select" value={editEntityData?.Course || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Course: e.target.value })}>
                                                    <option value="">Select</option>
                                                    {courseOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                                                </select>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Centre For Education</label>
                                                <select className="entity-select" value={editEntityData?.Centre_For_Education || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Centre_For_Education: e.target.value })}>
                                                    <option value="">Select</option>
                                                    <option value="Delhi">Delhi</option>
                                                    <option value="Jaipur">Jaipur</option>
                                                    <option value="Kota">Kota</option>
                                                    <option value="Lucknow">Lucknow</option>
                                                </select>
                                            </div>

                                            {/* Row 9 */}
                                            <div className="entity-field-group">
                                                <label>Whatsapp Response</label>
                                                <input type="text" className="entity-input" value={editEntityData?.whatsaap_response || ''} onChange={(e) => setEditEntityData({ ...editEntityData, whatsaap_response: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Response</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Response || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Response: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>User Code</label>
                                                <input type="text" className="entity-input" value={editEntityData?.User_Code || ''} onChange={(e) => setEditEntityData({ ...editEntityData, User_Code: e.target.value })} />
                                            </div>

                                            {/* Row 10 */}
                                            <div className="entity-field-group">
                                                <label>Company Incorporation Date</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Company_Incorporation_Date ? editEntityData.Company_Incorporation_Date.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Company_Incorporation_Date: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>MCA Registered City</label>
                                                <input type="text" className="entity-input" value={editEntityData?.MCA_Registered_City || ''} onChange={(e) => setEditEntityData({ ...editEntityData, MCA_Registered_City: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Equity Percentage</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Equity_Percentage || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Equity_Percentage: e.target.value })} />
                                            </div>

                                            {/* Row 11 */}
                                            <div className="entity-field-group">
                                                <label>Mandate Start Date</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Mandate_Start_Date ? editEntityData.Mandate_Start_Date.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Mandate_Start_Date: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Mandate End Date</label>
                                                <input type="date" className="entity-input" value={editEntityData?.Mandate_End_Date ? editEntityData.Mandate_End_Date.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, Mandate_End_Date: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>OPE Preapproval</label>
                                                <input type="text" className="entity-input" value={editEntityData?.OPE_Preapproval || ''} onChange={(e) => setEditEntityData({ ...editEntityData, OPE_Preapproval: e.target.value })} />
                                            </div>

                                            {/* Row 12 */}
                                            <div className="entity-field-group">
                                                <label>Business Referral Mandate</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Business_Referral_Mandate || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Business_Referral_Mandate: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Addendum</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Addendum || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Addendum: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Project Name</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Project_Name || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Project_Name: e.target.value })} />
                                            </div>

                                            {/* Row 13 - Radio Fields */}
                                            <div className="entity-field-group">
                                                <label>Is Adult</label>
                                                <div className="entity-radio-group">
                                                    <label className="entity-radio-label"><input type="radio" className="entity-radio-input" name="is_Adult" value="yes" checked={editEntityData?.is_Adult === 'yes'} onChange={(e) => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> Yes</label>
                                                    <label className="entity-radio-label"><input type="radio" className="entity-radio-input" name="is_Adult" value="no" checked={editEntityData?.is_Adult === 'no'} onChange={(e) => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> No</label>
                                                    <label className="entity-radio-label"><input type="radio" className="entity-radio-input" name="is_Adult" value="don't wish to answer" checked={editEntityData?.is_Adult === "don't wish to answer"} onChange={(e) => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> Don't wish to answer</label>
                                                </div>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Locate Our Office</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Locate_Our_Office || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Locate_Our_Office: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Number of Users</label>
                                                <input type="text" className="entity-input" value={editEntityData?.number_of_users || ''} onChange={(e) => setEditEntityData({ ...editEntityData, number_of_users: e.target.value })} />
                                            </div>

                                            {/* Row 14 */}
                                            <div className="entity-field-group">
                                                <label>Pending Amount</label>
                                                <input type="text" className="entity-input" value={editEntityData?.pending_amount || ''} onChange={(e) => setEditEntityData({ ...editEntityData, pending_amount: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Warranty Valid Till</label>
                                                <input type="date" className="entity-input" value={editEntityData?.warranty_valid_till ? editEntityData.warranty_valid_till.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, warranty_valid_till: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Warranty Start Date</label>
                                                <input type="date" className="entity-input" value={editEntityData?.warranty_start_date ? editEntityData.warranty_start_date.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, warranty_start_date: e.target.value })} />
                                            </div>

                                            {/* Row 15 */}
                                            <div className="entity-field-group">
                                                <label>Product</label>
                                                <input type="text" className="entity-input" value={editEntityData?.product || ''} onChange={(e) => setEditEntityData({ ...editEntityData, product: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Select Option</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Select_Option || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Select_Option: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Date Time</label>
                                                <input type="date" className="entity-input" value={editEntityData?.DATE_TIME ? editEntityData.DATE_TIME.split('T')[0] : ''} onChange={(e) => setEditEntityData({ ...editEntityData, DATE_TIME: e.target.value })} />
                                            </div>

                                            {/* Row 16 */}
                                            <div className="entity-field-group">
                                                <label>Monthly EMI</label>
                                                <input type="text" className="entity-input" value={editEntityData?.monthly_EMI || ''} onChange={(e) => setEditEntityData({ ...editEntityData, monthly_EMI: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Demo Date</label>
                                                <input type="text" className="entity-input" value={editEntityData?.Demo_date || ''} onChange={(e) => setEditEntityData({ ...editEntityData, Demo_date: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>New Test</label>
                                                <input type="text" className="entity-input" value={editEntityData?.new_test || ''} onChange={(e) => setEditEntityData({ ...editEntityData, new_test: e.target.value })} />
                                            </div>

                                            {/* Row 17 */}
                                            <div className="entity-field-group">
                                                <label>Pending Amount (KW)</label>
                                                <input type="text" className="entity-input" value={editEntityData?.pending_amount || ''} onChange={(e) => setEditEntityData({ ...editEntityData, pending_amount: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Testing</label>
                                                <input type="text" className="entity-input" value={editEntityData?.testing09099 || ''} onChange={(e) => setEditEntityData({ ...editEntityData, testing09099: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Upload Doc</label>
                                                <input type="text" className="entity-input" value={editEntityData?.upload_doc || ''} onChange={(e) => setEditEntityData({ ...editEntityData, upload_doc: e.target.value })} />
                                            </div>

                                            {/* Row 18 - Gender Radio */}
                                            <div className="entity-field-group">
                                                <label>Gender</label>
                                                <div className="entity-radio-group">
                                                    <label className="entity-radio-label"><input type="radio" className="entity-radio-input" name="gender_edit" value="Male" checked={editEntityData?.gender === 'Male'} onChange={(e) => setEditEntityData({ ...editEntityData, gender: e.target.value })} /> Male</label>
                                                    <label className="entity-radio-label"><input type="radio" className="entity-radio-input" name="gender_edit" value="Female" checked={editEntityData?.gender === 'Female'} onChange={(e) => setEditEntityData({ ...editEntityData, gender: e.target.value })} /> Female</label>
                                                </div>
                                            </div>
                                            <div className="entity-field-group">
                                                <label>KW Requirement</label>
                                                <input type="text" className="entity-input" value={editEntityData?.KW_Requirement || ''} onChange={(e) => setEditEntityData({ ...editEntityData, KW_Requirement: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Official Address</label>
                                                <input type="text" className="entity-input" value={editEntityData?.official_address || ''} onChange={(e) => setEditEntityData({ ...editEntityData, official_address: e.target.value })} />
                                            </div>

                                        </div>
                                    </div>



                                </>
                            )}
                        </div>

                        {currentOperationMode !== 'none' && (
                            <div className="entity-operations-area">
                                <div className="op-content">
                                    <OperationsForms
                                        mode={currentOperationMode}
                                        task={editingEntity}
                                        onBack={() => setCurrentOperationMode('none')}
                                        onSuccess={() => {
                                            fetchEntityDetails();
                                            setCurrentOperationMode('none');
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="entity-action-sidebar">
                            {[
                                { mode: 'mail', icon: Mail, title: 'Send Mail' },
                                { mode: 'sms', icon: MessageSquare, title: 'Send SMS' },
                                { mode: 'voice', icon: Mic, title: 'Send Voice' },
                                { mode: 'whatsapp', icon: MessageCircle, title: 'WhatsApp' }
                            ].map((item, idx) => (
                                <button
                                    key={item.mode}
                                    className={`sidebar-action-btn ${currentOperationMode === item.mode ? 'active' : ''}`}
                                    onClick={() => setCurrentOperationMode(item.mode)}
                                    title={item.title}
                                >
                                    <item.icon size={18} color={item.color} />
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntityEdit;
